export const leadership = [
  {
    company: 'BSO UTA',
    role: 'Joint Organizing Secretary',
    period: 'July 2025 – Present',
    location: 'Bangladeshi Student Organization, University of Texas at Arlington',
    type: 'Leadership',
    highlights: [
      'Strategically led collaboration between student leaders, alumni, and university administration to design and execute high-impact programs for 500+ Bangladeshi students, fostering community, professional growth, and cultural engagement.',
      'Developed and managed digital workflows and software tools for event registration, scheduling, and communications, improving operational efficiency and participant engagement by 40%.',
      'Established and nurtured partnerships with international Bangladeshi student associations and alumni networks, creating global initiatives connecting students across multiple universities.',
      'Organized large-scale mentorship programs, speaker series, and networking events with measurable outcomes: increased alumni-student engagement, career guidance opportunities, and cross-campus collaborations.',
      'Introduced data-driven evaluation and reporting methods for all programs, tracking participation metrics, feedback, and long-term community impact.',
      'Mentored junior leaders and volunteers, cultivating a scalable leadership pipeline for the organization\'s future growth.',
      'Collaborated with university departments to improve cultural representation, student inclusion, and global community-building efforts.',
      'Drove initiative planning using OKR-style goal tracking to measure impact and improve program scalability.',
    ],
  },
  {
    company: 'Lal Sabuj Unnayan Sangha',
    role: 'President',
    period: 'Jan 2020 – Jan 2021',
    location: 'Rajshahi, Bangladesh',
    type: 'Non-Profit Leadership',
    highlights: [
      'Led environmental education programs reaching 3M+ students across 20+ educational institutions.',
      'Organized tree plantation campaigns that planted 1M+ trees, contributing to regional reforestation efforts.',
      'Managed team of 50+ volunteers coordinating awareness campaigns and sustainability workshops.',
      'Established partnerships with local government and administrative bodies to expand program reach and ensure long-term impact.',
    ],
  },
];
